import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { SSOMsalService } from "./sso-msal.service";
import { AuthService } from "src/app/modules/auth";
import { AuthRecoveryService } from "../http/auth-recovery.service";
import { filter, take, timeout } from "rxjs/operators";

@Component({
  selector: "app-sso-msal",
  template: "<router-outlet></router-outlet>",
})
export class SsoMsalComponent implements OnInit {
  constructor(
    private router: Router,
    private ssoMsalService: SSOMsalService,
    private msalBroadcastService: MsalBroadcastService,
    private authMsalService: MsalService,
    private authService: AuthService,
    private authRecovery: AuthRecoveryService,
  ) {}

  ngOnInit(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        take(1),
        /**
         * Bắt buộc phải có timeout. inProgress$ là stream vô hạn: nếu MSAL kẹt ở một
         * trạng thái khác None thì filter() không bao giờ phát giá trị, completeSignIn()
         * không bao giờ chạy. Template của component này chỉ là router-outlet rỗng nên
         * người dùng đứng nhìn màn hình TRẮNG, không popup, không log - không có cách nào
         * biết chuyện gì đang xảy ra.
         */
        timeout(this.authRecovery.msalIdleTimeoutMs),
      )
      .subscribe({
        next: () => this.completeSignIn(),
        error: (error) => {
          console.error('[SSO] Hết thời gian chờ MSAL sẵn sàng ở trang callback.', {
            timeoutMs: this.authRecovery.msalIdleTimeoutMs,
            error,
          });
          this.ssoMsalService.recoverAuthentication({
            errorCode: 'msal_idle_timeout',
            message: `MSAL did not reach InteractionStatus.None within ${this.authRecovery.msalIdleTimeoutMs}ms.`,
          });
        },
      });
  }

  private completeSignIn(): void {
    this.ssoMsalService.checkAndSetActiveAccount();

    const account = this.authMsalService.instance.getActiveAccount();
    if (!account) {
      this.ssoMsalService.recoverAuthentication({
        errorCode: "no_account",
        message: "No active MSAL account is available.",
      });
      return;
    }

    if (this.authService.getAuthFromLocalStorage()) {
      this.router.navigate(["/"]);
      return;
    }

    this.authMsalService.acquireTokenSilent({
      scopes: ["openid", "user.read"],
      account,
      forceRefresh: false,
    }).subscribe({
      next: (tokenResult) => this.ssoMsalService.storageSsoMsalToken(tokenResult, this.router),
      error: (error) => this.ssoMsalService.recoverAuthentication(error),
    });
  }
}
